import styled from "styled-components";

export const ContainerSubNavbar = styled.div`
  max-width: 247px;
  border-radius: 20px;
  padding: 10px;
  background: linear-gradient(350deg, #24282f -2.06%, #16181d 102.08%);
  position: relative;
  display: flex;
  flex-flow: column;
  gap: 10px;
  overflow: visible; /* <— para que el arrow no se recorte */

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 80%;
    max-width: 247px;
    transform: ${({ show }) => (show ? "translateX(0)" : "translateX(-100%)")};
    transition: transform 0.3s ease-in-out;

    overflow: visible; /* <— idem en móvil */
  }
`;

export const ContainerSubNavbarOption = styled.div`
  border-radius: 100px;
  padding: 10px;
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
`;

export const IconSVO = styled.img`
  width: 28px;
  height: 28px;
`;

export const IconSVOText = styled.div`
  width: 28px;
  height: 28px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentSVO = styled.span`
  color: white;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 400;
  line-height: 16.94px;
`;

export const ContainerSubNavbarOptionArrow = styled.div`
  display: flex;
  cursor: pointer;
  position: absolute;
  top: 45%;
  right: -20px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  padding: 6px;
  background-color: rgba(0, 0, 0, 0.403);
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    position: fixed;
    top: 16px;
    left: 8px;
    right: auto;
    transform: none !important;
  }
`;
